import React from 'react'
import PropTypes from 'prop-types'
import Avatar from 'shared/components/common/Avatar/Avatar.component'
import { createDivAtom } from 'shared/atoms/factory'

import styles from './Active.module.scss'

const ActiveWrapper = createDivAtom(),
      OrganisationName = createDivAtom()

const Active = ({ organisation, profile }) => (
  <ActiveWrapper
    className={styles.wrapper}
  >
    <OrganisationName
      className={styles.organisationName}
    >
      {organisation?.name}
    </OrganisationName>

    <Avatar
      subject={{
        name: organisation?.name,
        picture: profile?.picture
      }}
      size='small'
    />
  </ActiveWrapper>
)


Active.propTypes = {
  organisation: PropTypes.object.isRequired,
  profile: PropTypes.object
}

export default Active
